export default function auth({ to, next, store }) {
  // Allow unauthenticated access to demo mode
  if (to.params.teamPid === 'demo') {
    return next()
  }

  const authStore = useAuthStore()
  authStore
    .getUser()
    .then(() => {
      next()
    })
    .catch(() => {
      next({ name: ROUTES.LOGIN })
    })
}
